import * as SDK from '@replai-platform/sdk';
import { QueryFunction, useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import * as provider from '../../api/provider';

const getTagTypeMetrics = async (requestParams: SDK.GetTagTypeMetricsRequest) => {
  const res = await provider.getJson<object, SDK.GetTagsMetricsResponse>(
    `${SDK.BASE_URL()}/tags/type/metrics?${SDK.convertRequestToQueryParams(requestParams)}`
  );
  return res;
};

const KEY = 'tag-type-metrics';
type Key = typeof KEY;

type Result = SDK.GetTagsMetricsResponse;
type QueryKey = [Key, SDK.GetTagTypeMetricsRequest];

type QueryOptions<R = Result> = UseQueryOptions<Result, unknown, R, QueryKey>;
type QueryResult<R = Result> = UseQueryResult<R>;

const queryFn: QueryFunction<Result, QueryKey> = ({ queryKey: [, requestParams] }) => getTagTypeMetrics(requestParams);

// This is exported so we can use useQueries
export function getTagTypeMetricsQueryOptions<R = Result>(
  requestParams: SDK.GetTagTypeMetricsRequest,
  options?: QueryOptions<R>
): QueryOptions<R> {
  return {
    queryKey: [KEY, requestParams],
    queryFn,
    ...options,
  };
}

export default function useTagMetrics<R = Result>(
  requestParams: SDK.GetTagTypeMetricsRequest,
  options?: QueryOptions<R>
): QueryResult<R> {
  return useQuery(getTagTypeMetricsQueryOptions(requestParams, options));
}
